import { useAppSelector } from '../../store/hooks';
import type { ResponsiveState } from '../../types';

const useResponsiveRedux = (): ResponsiveState => {
  const responsive = useAppSelector((state) => state.responsive);

  return {
    isMobile: responsive.isMobile,
    isTablet: responsive.isTablet,
    isDesktop: responsive.isDesktop,
    width: responsive.width,
    breakpoints: responsive.breakpoints,
  };
};

export default useResponsiveRedux;
